<div class="DTX_CAROUSEL">
    <p-carousel [value]="carouselData.Rows" [numVisible]="1" [numScroll]="1" [circular]="true" [autoplayInterval]="3000">
        <ng-template let-row pTemplate="item">
            <div>
                <app-row [row]="row" />
            </div>
        </ng-template>
    </p-carousel>
</div>
